import { useMemo, useState } from 'react';
import {
	Box,
	Button,
	Flex,
	Grid,
	GridItem,
	H4,
	Panel,
	Small,
	Text,
} from '@bigcommerce/big-design';
import useSubmitOrder from '../../../hooks/useSubmitOrder';
import { useSubtotal } from '../../../hooks/useSubtotal';
import OrderSummary from '../../OrderSummary';
import OrderTotals from '../../OrderTotals';
import PaymentDetails from '../../PaymentDetails';
import CustomerAddressSummary from './CustomerAddressSummary';

export function OrderSummarySection({ customer, products }) {
	const [payment, setPayment] = useState({ payment_type: 'Manual' });
	const [isPlacingOrder, submitOrder] = useSubmitOrder();
	const { saleTotal, regularTotal } = useSubtotal(products);

	function setPaymentInfo(name, value) {
		const paymentCopy = { ...payment }; // get a copy of the current customer
		paymentCopy[name] = value;
		setPayment({ ...paymentCopy });
	}

	// Get the value of shipping charge, making sure to account for empty value and strings.
	const shippingCharge = useMemo(() => {
		const amount = parseFloat(payment.shipping_charge);

		if (isNaN(amount)) return 0;

		return amount;
	}, [payment]);

	return (
		<Panel
			marginTop="xxxLarge"
			header="Order Summary"
			action={{
				text: 'Place Order',
				onClick: () => submitOrder(customer, payment, products),
				isLoading: isPlacingOrder,
			}}
		>
			<Grid className="summary-container">
				<GridItem>
					<PaymentDetails
						onOptionChange={(value) =>
							setPaymentInfo('payment_type', value)
						}
						payment={payment}
						setPaymentInfo={setPaymentInfo}
					/>
				</GridItem>
				<GridItem>
					<Grid gridColumns="1fr 350px">
						<GridItem gridRow="1" gridColumnStart="span 2">
							<OrderSummary products={products} />
						</GridItem>

						<GridItem gridRow="2" gridColumn="2">
							<Box borderRadius="normal" paddingTop="xxxLarge">
								<H4 marginBottom="none">Customer Name</H4>
								{!customer.first_name || !customer.last_name ? (
									<Small>Customer Not Specified</Small>
								) : (
									<Text>
										{customer.first_name || ''}{' '}
										{customer.last_name || ''}
									</Text>
								)}
								<H4 marginBottom="none">Customer Address</H4>
								<CustomerAddressSummary
									address={customer.shipping_address}
								/>

								<OrderTotals
									regularSubTotal={regularTotal}
									saleSubtotal={saleTotal}
									shippingCharge={shippingCharge}
									orderTotal={shippingCharge + saleTotal}
								/>
								<Flex
									marginTop="large"
									justifyContent="flex-end"
								>
									<Button
										onClick={() =>
											submitOrder(
												customer,
												payment,
												products,
											)
										}
										isLoading={isPlacingOrder}
									>
										Place Order
									</Button>
								</Flex>
							</Box>
						</GridItem>
					</Grid>
				</GridItem>
			</Grid>
		</Panel>
	);
}
